<div (furyClickOutside)="onClickOutside()" class="toolbar-user" fxFlex="grow">
  <button (click)="toggleDropdown()" [class.open]="isOpen" class="button" fxFlex="grow" mat-button>
    <span fxLayout="row" fxLayoutAlign="start center">
      <mat-icon>account_circle</mat-icon>
      <span class="name" fxHide fxShow.gt-sm>{{ (authenticationService.user$ | async)?.name }}</span>
      <mat-icon class="icon" fxHide fxShow.gt-sm>keyboard_arrow_down</mat-icon>
    </span>
  </button>

  <div [class.open]="isOpen" class="dropdown">
    <div class="content">
      <div class="list">
        <div class="list-item non-clickable">
          <div>
            <mat-icon class="list-item-icon">verified_user</mat-icon>
            <span>{{ (authenticationService.user$ | async)?.role }}</span>
          </div>
        </div>
        <div [routerLink]="['/auth/account']" class="list-item" matRipple>
          <div>
            <mat-icon class="list-item-icon">account_circle</mat-icon>
            <span>Profiel</span>
          </div>
        </div>
        <div class="list-item" matRipple [routerLink]="['/auth/beschikbaarheid']">
          <div>
            <mat-icon class="list-item-icon">event_available</mat-icon>
            <span>Beschikbaarheid</span>
          </div>
        </div>
        <div (click)="stopImpersonating()"
             *ngIf="(authenticationService.user$ | async)?.impersonated_by" class="list-item"
             matRipple>
          <div>
            <mat-icon class="list-item-icon">clear</mat-icon>
            <span>Stop impersonating user</span>
          </div>
          <mat-spinner *ngIf="isLoadingImpersonation" diameter="24"></mat-spinner>
        </div>
        <div *ngIf="!(authenticationService.user$ | async)?.impersonated_by"
             [routerLink]="['/auth/change-password']" class="list-item" matRipple>
          <div>
            <mat-icon class="list-item-icon">settings</mat-icon>
            <span>Wachtwoord aanpassen</span>
          </div>
        </div>
        <ng-container *ngIf="(authenticationService.organisation$ | async)?.domains.length">
          <mat-divider></mat-divider>
          <div (click)="showListOfOtherApps()" class="list-item" matRipple>
            <div>
              <mat-icon class="list-item-icon">apps</mat-icon>
              <span>Other apps</span>
            </div>
          </div>
        </ng-container>
        <mat-divider></mat-divider>
        <div [routerLink]="['/handleiding']" class="list-item" matRipple>
          <div>
            <mat-icon class="list-item-icon">help</mat-icon>
            <span>Help & support</span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div (click)="captureBug()" class="list-item marker-report-a-bug" matRipple>
          <div>
            <mat-icon class="list-item-icon">bug_report</mat-icon>
            <span>Een probleem melden</span>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div (click)="logout()" class="list-item" matRipple>
          <div>
            <mat-icon class="list-item-icon">exit_to_app</mat-icon>
            <span>Logout</span>
          </div>
          <mat-spinner *ngIf="isLoadingLogout" diameter="24"></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
